module.exports = __webpack_public_path__ + "img/2.96103719.png";